import { useEffect, useState } from 'react';
import { API, axios } from '../../utils/api';
import AZIENDA from '../../config/azienda';

// Consulente del cliente (nome, numero, foto): dal backend; se non risponde, il collaboratore scritto sul
// cliente e il numero dell'ufficio. La usano la home e le pagine degli immobili.
export const consulenteDaMostrare = (dati, cliente) => {
  const nome = dati?.nome || (cliente?.inserito_da_collaboratore_nome || '').split(' ')[0] || AZIENDA.nome;
  return { nome, cognome: dati?.cognome || '', telefono: dati?.telefono || AZIENDA.telefono, foto_url: dati?.foto_url || null };
};

export const caricaConsulente = async (clienteId) => {
  try {
    const r = await axios.get(`${API}/clienti/${clienteId}/consulente`);
    if (r.data?.nome) return consulenteDaMostrare(r.data, null);
  } catch { /* backend senza la rotta: sotto */ }
  try {
    const r = await axios.get(`${API}/clienti/${clienteId}`);
    return consulenteDaMostrare(null, r.data);
  } catch {
    return consulenteDaMostrare(null, null);
  }
};

export const useConsulente = (clienteId) => {
  const [consulente, setConsulente] = useState(() => consulenteDaMostrare(null, null));
  useEffect(() => {
    let attivo = true;
    if (clienteId) caricaConsulente(clienteId).then((c) => { if (attivo) setConsulente(c); });
    return () => { attivo = false; };
  }, [clienteId]);
  return consulente;
};
